module.exports = "/_next/static/images/Mihai_Budac-34cb58c58a66d881efbed4d66f5f2c58.webp";